import './Amenities.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

const Amenities = () => {
  return (
    <div data-aos="fade-up"
      data-aos-duration="1000">
      <div className='amenities-top'>
        <h3>AMENITIES AT A GLANCE</h3>
      </div>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide><img src="./ParkPhotos/Amenities/1.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/2.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/4.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/5.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/6.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/7.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/8.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/9.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./ParkPhotos/Amenities/10.jpg" alt="AenitiesPics" /></SwiperSlide>
      </Swiper>
    </div>
  )
}

export default Amenities










